import React, { Component } from "react";
import FieldWrapper from './FieldWrapper.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import CustomAlert from './CustomAlert.js';
import apiService from '../services/apiService.js';
import { change } from 'redux-form';

class CarAsPaymentModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      requestError: false,
      showContinueButton: false,
      carBrandOptions: [],
      carLineOptions: [],
      CarModelOptionsbyLine: [],
      carModelOptions: [],
      carYearOptions: [],
      selectedBrand: null,
      selectedModel: null,
      selectedLine: null,
      selectedModelYear: null,
      noLinesAvailable: false,
      noModelsAvailable: false,
    };
  }

  async componentDidMount() {
    this.fetchBrands();
  }

  fetchBrands = async () => {
    try {
      this.setState({ isLoading: true });
      const { dispatch } = this.props;
      dispatch(change('CarAsPaymentForm', 'car_brand', null));
      const carBrandOptions = [];
      const response = await apiService.getResource('/subscribers/car_quote_brands');
      Object.keys(response.data.brands).map((element, index) => {
        carBrandOptions.push({ id: index, name: element });
      })
      this.setState({
        carBrandOptions: carBrandOptions,
        requestError: false
      });
    } catch (error) {
      this.setState({ requestError: true });
      console.error('Error fetching brands:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  handleBrandSelect = async (brandId) => {
    const selectedBrand = this.state.carBrandOptions.find(brand => brand.id === Number(brandId));
    this.setState({ selectedBrand: selectedBrand.name, isLoading: true });
    try {
      const carLineOptions = [];
      const response = await apiService.getResource(`/subscribers/car_quote_lines/${selectedBrand.name}`);
      Object.keys(response.data.cars).map((element, index) => {
        carLineOptions.push({ id: index, name: element });
      })
      this.setState({
        carLineOptions: carLineOptions,
        CarModelOptionsbyLine: response.data.cars,
        noLinesAvailable: response.data.cars.length === 0,
        carModelOptions: [],
        carYearOptions: [],
        selectedModel: null,
        selectedLine: null,
        selectedModelYear: null,
        requestError: false
      });
      const { dispatch } = this.props;
      dispatch(change('CarAsPaymentForm', 'car_line', null));
      dispatch(change('CarAsPaymentForm', 'car_model', null));
      dispatch(change('CarAsPaymentForm', 'car_year', null));
    } catch (error) {
      this.setState({ requestError: true });
      console.error('Error fetching models:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  handleLineSelect = (lineId) => {
    const { carLineOptions, CarModelOptionsbyLine } = this.state;
    const selectedLine = carLineOptions.find(line => line.id === Number(lineId));
    const carModelOptions = [];
    Object.keys(CarModelOptionsbyLine[selectedLine.name]).map((element, index) => {
      carModelOptions.push({ id: index, name: element });
    })
    this.setState({
      selectedLine: selectedLine.name,
      carModelOptions: carModelOptions,
      noModelsAvailable: Object.keys(CarModelOptionsbyLine[selectedLine.name]).length === 0,
      selectedModel: null,
      selectedModelYear: null,
      carYearOptions: [],
      requestError: false
    });
    const { dispatch } = this.props;
    dispatch(change('CarAsPaymentForm', 'car_model', null));
    dispatch(change('CarAsPaymentForm', 'car_year', null));
  }

  handleModelSelect = (modelId) => {
    const { carModelOptions } = this.state;
    const selectedModel = carModelOptions.find(line => line.id === Number(modelId));
    this.setState({ selectedModel: selectedModel.name })
    const carYearOptions = [];
    for (let index = 0; index < 15; index++) {
      carYearOptions.push({ id: index, name: parseInt(new Date().getFullYear(), 10) - index });
    }
    this.setState({
      carYearOptions: carYearOptions,
      noYearsAvailable: carYearOptions.length === 0,
      selectedModelYear: null,
      requestError: false
    });
    const { dispatch } = this.props;
    dispatch(change('CarAsPaymentForm', 'car_year', null));
  }

  handleYearSelect = (yearId) => {
    const selectedYear = this.state.carYearOptions.find(y => y.id === Number(yearId));
    this.setState({ selectedModelYear: selectedYear.name });
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { selectedBrand, selectedLine, selectedModel, selectedModelYear } = this.state;
    const data = {
      brand: selectedBrand,
      line: selectedLine,
      model: selectedModel,
      year: selectedModelYear
    };
    try {
      this.setState({ isLoading: true });
      const response = await apiService.postResource('/subscribers/car_quote_price', data);
      if (response.status === 200) {
        const carPrice = response.data.cars
        const carName = `${selectedBrand} ${selectedLine} ${selectedModel}`;
        this.props.setCarDetails({
          car_model: carName,
          car_price: carPrice,
        });
        this.props.handleChildComponent('quote')
      }
    } catch (error) {
      this.setState({ requestError: true });
      console.error('Error submitting car information:', error);
    } finally {
      this.setState({ isLoading: false });
    }
  }


  render() {
    const { carBrandOptions, carModelOptions, carLineOptions, carYearOptions, isLoading, requestError, noModelsAvailable, noLinesAvailable, noYearsAvailable, selectedModelYear } = this.state;

    const requestErrorObj = { title: '¡Lo sentimos!', message: 'Ocurrió un problema al obtener la información de las ofertas disponibles. Volvé a intentarlo dentro de unos minutos.' };
    const noModelsAvailableObj = { title: '¡Lo sentimos!', message: 'No hay modelos disponibles para esta marca.' };
    const noLinesAvailableObj = { title: '¡Lo sentimos!', message: 'No hay modelos disponibles para esta marca.' };
    const noYearsAvailableObj = { title: '¡Lo sentimos!', message: 'No tenemos ofertas disponibles para este modelo.' };

    return (
      <FieldWrapper>
        {(isLoading) && <CustomSpinner message='Estamos buscando tu auto ideal' />}
        {requestError && <CustomAlert bsStyle="info" title={requestErrorObj.title} message={requestErrorObj.message} />}
        {noModelsAvailable && <CustomAlert bsStyle="info" title={noModelsAvailableObj.title} message={noModelsAvailableObj.message} />}
        {noLinesAvailable && <CustomAlert bsStyle="info" title={noLinesAvailableObj.title} message={noLinesAvailableObj.message} />}
        {noYearsAvailable && <CustomAlert bsStyle="info" title={noYearsAvailableObj.title} message={noYearsAvailableObj.message} />}
        <AttributeOptions name="car_brand" defaultValue="Marca" label="Marca" attributeOptions={carBrandOptions} onChange={this.handleBrandSelect} />
        {carLineOptions.length > 0 && <AttributeOptions name="car_line" defaultValue="Línea" label="Línea" attributeOptions={carLineOptions} onChange={this.handleLineSelect} />}
        {carModelOptions.length > 0 && <AttributeOptions name="car_model" defaultValue="Modelo" label="Modelo" attributeOptions={carModelOptions} onChange={this.handleModelSelect} />}
        {carYearOptions.length > 0 && <AttributeOptions name="car_year" defaultValue="Año" label="Año" attributeOptions={carYearOptions} onChange={this.handleYearSelect} />}
        <button onClick={this.handleSubmit} className="btn btn-warning btn-lg pd-button pd-form" disabled={!selectedModelYear}>Continuar</button>
      </FieldWrapper>
    );
  }
}

export default CarAsPaymentModel;



/** WEBPACK FOOTER **
 ** ./src/components/CarAsPaymentModelCarQuote.js
 **/